import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  RESET_LOGIN,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
} from './constants';

export const loginAction = (email: string, password: string) => ({
  type: LOGIN,
  email,
  password,
});

export const loginSuccessAction = () => ({ type: LOGIN_SUCCESS });

export const loginFailedAction = (error: Error, email: string) => ({
  type: LOGIN_FAILED,
  error,
  email,
});

export const resetLoginAction = () => ({ type: RESET_LOGIN });

export const logoutAction = () => ({ type: LOGOUT });

export const logoutSuccessAction = (token?: string) => ({
  type: LOGOUT_SUCCESS,
  token,
});

export const logoutFailedAction = (error: Error) => ({
  type: LOGOUT_FAILED,
  error,
});
